import { SearchPriority } from "interfaces/searchPage/osaSearch";

export enum ProductState {
	NO_STARTED_VALID_PATH = "30",
	NO_STARTED_VALID = "20",
	NO_STARTED_NO_VALID = "10",
	ELEARNING = "5",
	STARTED_ENDED = "0"
}

export const activeCourseProductStates = [
	ProductState.NO_STARTED_VALID_PATH,
	ProductState.NO_STARTED_VALID,
	ProductState.NO_STARTED_NO_VALID
];

export const inactiveCourseProductStates = [
	ProductState.STARTED_ENDED
];

export enum ReturnFields {
	IMAGE_URL = "imageurl_s",
	TITLE = "title",
	TITLE_IT = "title_it",
	TITLE_SORTING = "title_srt",
	AUTHORS = "authorslist_txt",
	PUBLISHER = "editore_txt",
	ID_PUBLISHER = "ideditore_facet",
	PUBLICATION_MONTH = "mesepubblicazione_i",
	PUBLICATION_YEAR = "annopubblicazione_i",
	SALES = "vendite_i",
	ID_ACCREDITATION = "idaccredito_facet",
	ID_LINE = "idlinee_facet",
	ID_ARGUMENTS = "idargomenti_facet",
	ABSTRACT = "abstract_txt",
	SUBTITLE = "sottotitolo_txt",
	ID_VARIANT = "variantid_l",
	CATEGORY_NAME = "categoryname_s",
	IS_IN_PRESALE = "isinpresale_b",
	PRESELLING_AND_DATE = "presellingenddate_dt",
	IS_AVAILABLE = "isavailable_b",
	VARIANT_TYPE = "varianttype_s",
	ACTUAL_PRICE = "actualprice_d",
	VARIANT_ID = "variantid_l",
	EXTENDED_REGULAR_PRICE = "extendedregularprice_d",
	EXTENDED_ACTUAL_PRICE = "extendedactualprice_d",
	CATEGORY_VALUES = "categoryvalues_ss",
	MAX_SELLING_QUANTITY = "maxsellingquantity_s",
	REGULAR_PRICE = "regularpice_d",
	CURRENCY_SYMBOL = "currencysymbol_s",
	HAS_MORE_VARIANT = "hasmorevariant_b",
	TAX = "tax_d",
	VALIDITY_DATE = "datavalidita_dt",
	PROMOTION_NAME = "promotionname_s",
	DESCRIPTION_HTML = "descrizione_txt",
	DESCRIPTION = "descrizione_it",
	TAG_NAME = "tag_ss",
	TAG_ID = "tag_facet",
	ENVIRONMENT = "environmentkey_srt",
	ID_VENUE = "idvenue_facet",
	VENUES = "venue_ss",
	VENUES_START_TIME = "venuestarttime_dts",
	VENUES_END_TIME = "venueendtime_dts",
	VENUES_CITY_ID = "venuecityid_ds",
	VENUES_CITY_NAME = "venuecityname_ss",
	VENUES_REGION_ID = "venueregionid_ds",
	VENUES_REGION_NAME = "venueregionname_ss",
	IS_VISIBLE_VENUE = "venueisvisible_bs",
	IS_OUTDATED_VENUE = "venueisoutdated_bs",
	MIN_LEFT_DAYS = "minleftdays_l",
	MIN_START_DATE = "minstart_dt",
	MIN_NOT_START_DATE = "minnotstarted_dt",
	SELLING_OPTIONS = "vendite_d",
	MINIMUM_PRICE = "minimumprice_d",
	PRODUCT_STATE = "productstate_l",
	PAGE_URL = "pageurl_s",
	PRODUCT_TYPE = "producttype_l",
	LISTING_LINE_DESCRIPTION = "listinglinedescription_txt",
	SCORE = "score"
}

export enum SortingValue {
	ASC = 0,
	DESC = 1
}

export enum Sorting {
	DATE = "date",
	ALPHABETICAL = "a-z",
	PRICE = "price",
	RELEVANCE = "relevance"
}

enum CompleteWordSearch {
	TITLE = "title_it",
	ABSTRACT = "abstract_it",
	GOAL = "goal_it",
	PROGRAM = "programma_it",
	VENUE_TITLE = "venue_it_mv",
	CREDITS = "accredito_it_mv",
	VENUE_AUTHORS = "autoresede_it_mv",
	COURSE_AUTHORS = "autori_it_mv",
	TAGS = "tag_it_mv"
}
enum PartialWordSearch {
	TITLE = "title_txt_ngrams",
	ABSTRACT = "abstract_txt_ngrams",
	GOAL = "goal_txt_ngrams",
	PROGRAM = "programma_txt_ngrams",
	VENUE_TITLE = "venue_txt_ngrams_mv",
	CREDITS = "accredito_txt_ngrams_mv",
	VENUE_AUTHORS = "autoresede_txt_ngrams_mv",
	COURSE_AUTHORS = "autori_txt_ngrams_mv",
	TAGS = "tag_txt_ngrams_mv"
}

export const getQueryPriority = (): SearchPriority[] => [
	{ Key: CompleteWordSearch.TITLE, Value: "25" },
	{ Key: PartialWordSearch.TITLE, Value: "20" },

	//{ Key: CompleteWordSearch.ABSTRACT, Value: "3" },
	// { Key: PartialWordSearch.ABSTRACT, Value: "4" },

	//{ Key: CompleteWordSearch.GOAL, Value: "5" },
	// { Key: PartialWordSearch.GOAL, Value: "6" },

	//{ Key: CompleteWordSearch.PROGRAM, Value: "7" },
	// { Key: PartialWordSearch.PROGRAM, Value: "8" },

	//{ Key: CompleteWordSearch.VENUE_TITLE, Value: "9" },
	// { Key: PartialWordSearch.VENUE_TITLE, Value: "10" },

	//{ Key: CompleteWordSearch.CREDITS, Value: "11" },
	// { Key: PartialWordSearch.CREDITS, Value: "12" },

	{ Key: CompleteWordSearch.VENUE_AUTHORS, Value: "10" },
	{ Key: PartialWordSearch.VENUE_AUTHORS, Value: "5" },

	//{ Key: CompleteWordSearch.COURSE_AUTHORS, Value: "15" },
	// { Key: PartialWordSearch.COURSE_AUTHORS, Value: "16" },

	{ Key: CompleteWordSearch.TAGS, Value: "2" },
	// { Key: PartialWordSearch.TAGS, Value: "18" },
];
